export const MAX_SNIPPET_NAME_LENGTH = 60;
export const SNIPPET_NAME_CUTOFF_LENGTH = 40;
export const MAX_SNIPPET_DESCRIPTION_LENGTH = 120;
export const SNIPPET_DESCRIPTION_CUTOFF_LENGTH = 60;

/**
 * Form values for snippet modals (Create/Edit/Duplicate).
 * Shared by SnippetBaseModal and the three mode modals.
 */
export type SnippetBaseModalFormValues = {
	snippetName: string;
	snippetDescription: string;
	/** Only present when site sharing is enabled. true = Shared, false = Private. Not sent to BE. */
	isShared?: boolean;
};

/**
 * Returns base form values only. Each modal overrides the fields it needs.
 */
export function getDefaultFormValues(includeSharingField: boolean): SnippetBaseModalFormValues {
	const values: SnippetBaseModalFormValues = {
		snippetName: '',
		snippetDescription: '',
	};
	if (includeSharingField) {
		values.isShared = false;
	}
	return values;
}
